import React, { useCallback } from 'react';
import { Dialog } from 'antd-mobile';
import service from '@/service';
import { storagePrefixV2 } from '@/constant';

import cx from './index.module.scss';

export type DeviceErrorStatus =
  /** 播放设备异常 */
  | 'PlayDeviceException'
  /** 播放设备运作异常 */
  | 'PlayDeviceRunningException'
  /** 播放设备忙 */
  | 'PlayDeviceBusy'
  /** 播放设备找不到 */
  | 'PlayDeviceNotFound'
  /** 麦克风运作异常 */
  | 'MicRunningException'
  /** 麦克风设备忙 */
  | 'MicBusy'
  /** 麦克风设备找不到 */
  | 'MicNotFound'
  /** 网络连接断开-播放设备检测 */
  | 'NetworkDisconnectInDetectPlayDevice'
  /** 网络连接断开-麦克风检测 */
  | 'NetworkDisconnectInDetectMicDevice';

interface Props {
  errorState: DeviceErrorStatus;
  onClearBusyPlayDevice: VoidFunc;
  deviceInfo: DeviceItem;
}

interface ErrorInfo {
  title: string;
  imgSrc?: string;
  errorTips: string;
}

const ERROR_STATE_INFO: Record<DeviceErrorStatus, ErrorInfo> = {
  PlayDeviceException: {
    title: '播放设备检测',
    imgSrc: storagePrefixV2 + '/voice-detect/play-device-exception.png',
    errorTips: '播放设备异常，请联系交付工程师处理。',
  },
  PlayDeviceRunningException: {
    title: '播放设备检测',
    imgSrc: storagePrefixV2 + '/voice-detect/play-device-running-error.png',
    errorTips: '播放设备运作异常',
  },
  PlayDeviceBusy: {
    title: '播放设备检测',
    imgSrc: storagePrefixV2 + '/voice-detect/play-device-not-found.png',
    errorTips: '播放设备忙',
  },
  PlayDeviceNotFound: {
    title: '播放设备检测',
    imgSrc: storagePrefixV2 + '/voice-detect/play-device-busy.png',
    errorTips: '播放设备找不到',
  },
  MicRunningException: {
    title: '麦克风设备检测',
    imgSrc: storagePrefixV2 + '/voice-detect/mic-running-error.png',
    errorTips: '麦克风运作异常',
  },
  MicBusy: {
    title: '麦克风设备检测',
    imgSrc: storagePrefixV2 + '/voice-detect/mic-busy.png',
    errorTips: '麦克风设备忙',
  },
  MicNotFound: {
    title: '麦克风设备检测',
    imgSrc: storagePrefixV2 + '/voice-detect/play-device-busy.png',
    errorTips: '麦克风设备找不到',
  },
  NetworkDisconnectInDetectPlayDevice: {
    title: '播放设备检测',
    errorTips: '网络已断开，重新连接后再次检测',
  },
  NetworkDisconnectInDetectMicDevice: {
    title: '麦克风设备检测',
    errorTips: '网络已断开，重新连接后再次检测',
  },
};

const DeviceError: React.FC<Props> = ({ errorState, onClearBusyPlayDevice, deviceInfo }) => {
  const handleClearBusyPlayDevice = useCallback(() => {
    Dialog.confirm({
      title: '确认要一键清除吗？',
      content: (
        <div>
          确认后将清除占用播放设备的
          <br />
          应用程序，且重新检测。
        </div>
      ),
      onConfirm: async () => {
        await service.lanInterface.speakerClearAll(deviceInfo?.deviceId);
        onClearBusyPlayDevice?.();
      },
    });
  }, [deviceInfo?.deviceId, onClearBusyPlayDevice]);

  return (
    <div className={cx('DeviceError')}>
      <div className={cx('title')}>{ERROR_STATE_INFO[errorState]?.title}</div>
      <div className={cx('content')}>
        {ERROR_STATE_INFO[errorState]?.imgSrc && (
          <img className={cx('img')} src={ERROR_STATE_INFO[errorState]?.imgSrc} alt="加载失败" />
        )}
        <div className={cx('error-tips')}>{ERROR_STATE_INFO[errorState]?.errorTips}</div>
        {errorState === 'PlayDeviceBusy' && (
          <div className={cx('extra-info')}>
            <div className={cx('clear')} onClick={handleClearBusyPlayDevice}>
              一键清除
            </div>
          </div>
        )}
        <div></div>
      </div>
    </div>
  );
};

export default DeviceError;
